import { db } from '../config/firebase';
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, getDoc } from 'firebase/firestore';

export const fetchClients = async () => {
  const clientsSnapshot = await getDocs(collection(db, 'clients'));
  return clientsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const fetchInvoices = async () => {
  const invoicesSnapshot = await getDocs(collection(db, 'invoices'));
  return invoicesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const createInvoice = async (invoice) => {
  // S'assurer que les dates sont bien définies et au bon format
  if (!invoice.created) {
    invoice.created = new Date();
  } else if (!(invoice.created instanceof Date)) {
    try {
      invoice.created = new Date(invoice.created);
      // Vérifier si la date est valide
      if (isNaN(invoice.created.getTime())) {
        invoice.created = new Date();
      }
    } catch (error) {
      invoice.created = new Date();
    }
  }
  
  if (invoice.prestaDate && !(invoice.prestaDate instanceof Date)) {
    try {
      invoice.prestaDate = new Date(invoice.prestaDate);
      // Vérifier si la date est valide
      if (isNaN(invoice.prestaDate.getTime())) {
        invoice.prestaDate = new Date();
      }
    } catch (error) {
      invoice.prestaDate = new Date();
    }
  }
  
  const docRef = await addDoc(collection(db, 'invoices'), invoice);
  return docRef.id;
};

export const updateInvoice = async (id, invoice) => {
  await updateDoc(doc(db, 'invoices', id), invoice);
};

export const deleteInvoice = async (invoiceId) => {
  try {
    await deleteDoc(doc(db, 'invoices', invoiceId));
  } catch (error) {
    console.error('Error deleting document: ', error);
  }
};

export const fetchClientById = async (id) => {
  const docRef = doc(db, 'clients', id);
  const docSnap = await getDoc(docRef);
  return docSnap.data();
};

export const fetchTrimestres = async () => {
  const trimestresSnapshot = await getDocs(collection(db, 'trimestres'));
  return trimestresSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const fetchInvoiceById = async (invoiceId) => {
  try {
    const invoiceDoc = await getDoc(doc(db, 'invoices', invoiceId));
    if (invoiceDoc.exists()) {
      return { id: invoiceDoc.id, ...invoiceDoc.data() };
    } else {
      console.error('Aucune facture trouvée avec cet ID:', invoiceId);
      return null;
    }
  } catch (error) {
    console.error('Erreur lors de la récupération de la facture:', error);
    return null;
  }
};

export const fetchQuotes = async () => {
  const quotesSnapshot = await getDocs(collection(db, 'quotes'));
  return quotesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const createQuote = async (quote) => {
  if (!(quote.created instanceof Date)) {
    quote.created = new Date(quote.created);
  }
  if (!(quote.prestaDate instanceof Date)) {
    quote.prestaDate = new Date(quote.prestaDate);
  }
  const docRef = await addDoc(collection(db, 'quotes'), quote);
  return docRef.id;
};
